module.exports = __webpack_public_path__ + "fonts/iconfont.b20ffa0.woff";